'use client';

import {Cart} from '@/components/cart/cart';

import {Poster} from './components/poster/poster';
import {Feed} from './components/feed/feed';

import {PRODUCTS_FEED_DATA_TESTID} from '../../utils/navigate-to-products';

import styles from './main-page.module.css';
import {UnavailableSitePoster} from './components/unavailable-site-poster/unavailable-site-poster';
import {useUserStatus} from '@/api/status';
import {Drawer, Space} from 'antd';
import {useState} from 'react';
import {useInfo} from '../infoContext';
import {MobileCartFloatButton} from '@/components/mobile-cart-float-button/mobile-cart-float-button';
import {Button} from '@/ui/button/button';
import {useCart} from '../cartContext';

const MainPage = () => {
    const {isMobile} = useInfo();

    const isAvailable = useUserStatus();
    const [isCartOpen, setIsCartOpen] = useState(false);
    const {clearCart} = useCart();

    return (
        <main>
            {!isAvailable && <UnavailableSitePoster isMobile={isMobile} />}

            {!isMobile && <Poster />}

            <section
                className={`${styles.feed} ${!isAvailable ? styles.unavailable : ''} ${isMobile ? styles.isMobile : ''}`}
                data-testid={PRODUCTS_FEED_DATA_TESTID}
            >
                <Feed isAvailable={!!isAvailable} />
                {!isMobile && isAvailable && (
                    <aside className={styles.cart}>
                        <Cart />
                    </aside>
                )}
            </section>
            {isMobile && isAvailable && <MobileCartFloatButton setIsCartOpen={setIsCartOpen} />}
            {isMobile && isAvailable && (
                <Drawer
                    open={isCartOpen}
                    onClose={() => setIsCartOpen(false)}
                    extra={
                        <Space>
                            <Button
                                type="ghost"
                                onClick={() => {
                                    setIsCartOpen(false);
                                    clearCart();
                                }}
                            >
                                Очистить корзину
                            </Button>
                        </Space>
                    }
                    styles={{
                        body: {background: '#F0F0F0', padding: 0},
                        header: {background: '#F0F0F0', border: 'none'},
                    }}
                >
                    <Cart />
                </Drawer>
            )}
        </main>
    );
};

export default MainPage;
